import React from 'react';
import Bugsnag from '@bugsnag/js';
import { getCurrentEnvironment } from '@/utils/environment-urls';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
  eventId?: string;
}

class ErrorBoundary extends React.Component<
  React.PropsWithChildren<{}>,
  ErrorBoundaryState
> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by BOUNDARY:', error, errorInfo);
    const enviroment = getCurrentEnvironment();
    if(enviroment !== 'production') return;
    
    Bugsnag.notify(error, (event) => {
      event.addMetadata('react', {
        componentStack: errorInfo.componentStack,
      });
      event.addMetadata('context', {
        section: 'error_boundary',
        component: 'global',
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href,
        userCode: JSON.parse(localStorage.getItem('userlogged') || '{}')?.codigo || 'unknown',
      });
    });
    
    this.setState({ eventId: 'error-reported' });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <h1 className="text-2xl font-bold mb-4">
              Ops! Algo deu errado
            </h1>
            <p className="text-gray-600 mb-6">
              Ocorreu um erro inesperado. Por favor, recarregue a página.
            </p>
            {this.state.eventId && (
              <p className="text-xs text-gray-400 mb-4">
                ID do erro: {this.state.eventId}
              </p>
            )}
            <div className='flex items-center justify-around mb-6 mx-auto'>
              <button
                onClick={() => window.location.reload()}
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Recarregar
              </button>
              <button
                onClick={() => window.location.href = '/'}
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Iníco
              </button>
            </div>

          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;